'use client';

import * as DS from '@aurorasolar/ds';
import { x } from '@xstyled/styled-components';

import { arcadeFont } from './arcadeFont';
import { Cabinet, GameOverModal, Hud } from './components';
import { useSolarSurge } from './useSolarSurge';

export const SolarSurge = () => {
  const { arm, bestDistance, canvasRef, highScore, hold, soundOn, start, stats, status, summary, toggleSound } =
    useSolarSurge();

  return (
    <x.section
      alignItems="center"
      className={arcadeFont.variable}
      display="flex"
      flexDirection="column"
      gap={6}
      maxW="720px"
      minH="calc(100dvh - 80px)"
      mx="auto"
      pb={{ _: 5, md: 8 }}
      pt={{ _: 5, md: 3 }}
      px={4}
    >
      <x.header display={{ _: 'none', md: 'block' }} maxW="720px" w="100%">
        <DS.Text as="h1" text={{ _: 'h2', md: 'h1' }}>
          Solar Surge
        </DS.Text>
        <DS.Text as="p" color="uiHelperCopy" mt={1} text="body16">
          Fly the sun, dodge the clouds, and learn how weather conditions change a solar array&apos;s output.
        </DS.Text>
      </x.header>

      <Cabinet
        highScore={highScore}
        onHold={hold}
        onStart={start}
        onToggleSound={toggleSound}
        ref={canvasRef}
        soundOn={soundOn}
        status={status}
      />

      <x.div display="flex" flexDirection="column" gap={4} maxW="720px" w="100%">
        <Hud bestDistance={bestDistance} highScore={highScore} stats={stats} />
      </x.div>

      <GameOverModal onPlayAgain={arm} summary={status === 'over' ? summary : null} />
    </x.section>
  );
};
